<template>
    <div style="padding: 20px">
        <Tabs value="name1" >
            <TabPane label="修改密码" name="name1">
                <div style="width: 400px;margin: 30px">
                    <Form  :label-width="80" style="padding-top: 50px" >
                        <FormItem label="原密码:">
                            <Input  v-model="formValidate.oldPass" type="password" :maxlength="21" placeholder="请输入原密码(6-21位)"></Input>
                        </FormItem>
                        <FormItem label="新密码:">
                            <Input  v-model="formValidate.newPass"  type="password"  :maxlength="21" placeholder="请输入新密码(6-21位)"></Input>
                        </FormItem>
                        <FormItem label="确认密码:">
                            <Input  v-model="formValidate.newPassY"  type="password"  :maxlength="21" placeholder="联系方式必填(6-21位)"></Input>
                        </FormItem>
                        <FormItem>
                            <Button type="primary" @click="saveMsg()">保存</Button>
                        </FormItem>
                    </Form>
                </div>
            </TabPane>
        </Tabs>
    </div>
</template>
<script>
    import encrypt from '@/common/encrypt';
    export default {
        components: {},
        data () {
            return {
                cid:"",
                oldPass:'',
                adminUserid:'',
                formValidate: {
                    oldPass: '',
                    newPass: '',
                    newPassY: '',
                },
            }
        },

        created: function() {
            //DOM更新完之前请求数据
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.adminUserid= JSON.parse(localStorage.getItem('adminUser')).id
            let getLocalPass = sessionStorage.getItem("rememberPass");
            this.oldPass= encrypt.Decrypt(getLocalPass, "3019")
        },
        methods: {
            //更新
            saveMsg(){
                if(this.formValidate.oldPass!=this.oldPass){
                    this.$Message.warning('原密码输入不正确');
                    return
                }
                if(this.formValidate.newPass==''){
                    this.$Message.warning('请输入新密码');
                    return
                }
                if(this.formValidate.newPassY==''){
                    this.$Message.warning('确认密码为空');
                    return
                }
                if(this.formValidate.newPassY!=this.formValidate.newPass){
                    this.$Message.warning('两次密码不一致');
                    return
                }

                this.$Api.updatePwd({
                    account: localStorage.getItem('rememberTel'),
                    password:this.formValidate.newPass
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success('修改成功！');
                        var isRemember = localStorage.getItem('isRemember')
                        var rememberTel = localStorage.getItem('rememberTel')
                        var rememberPass = localStorage.getItem('rememberPass')
                        localStorage.clear()
                        localStorage.setItem('isRemember',isRemember)
                        localStorage.setItem('rememberTel',rememberTel)
                        localStorage.setItem('rememberPass',rememberPass)
                        this.$router.push("/login");
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

        }
    }
</script>


<style  lang="scss" scoped>
    .server-title{
        display: inline-block;
        text-align: center;width: 88%
    }
    .logo{
        width: 50px;
        height: 50px;
        margin: auto;
    }
    .ivu-form-item{
        height: 30px;
    }
</style>